module.exports = __webpack_public_path__ + "img/40_38_068_070.d5704683.jpg";